import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { availabilityShape, bibShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import {
  selectManifestationsForCurrentBib,
  selectManifestationsSummary,
  selectEditionsForCurrentBib
} from 'app/selectors/catalogBibs/ManifestationsSelector';
import { selectAvailabilityEntities } from 'app/selectors/EntitiesSelector';

import ModalActions from 'app/actions/ModalActions';
import FormatChooser from './FormatChooser';

export class FormatChooserContainer extends React.PureComponent {
  render() {
    return <FormatChooser {...this.props} />;
  }
}

FormatChooserContainer.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  realtimeAvailabilities: ImmutablePropTypes.mapOf(availabilityShape).isRequired,
  manifestations: ImmutablePropTypes.listOf(bibShape).isRequired,
  editions: ImmutablePropTypes.listOf(bibShape).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  summary: ImmutablePropTypes.map.isRequired
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  realtimeAvailabilities: selectAvailabilityEntities(state),
  manifestations: selectManifestationsForCurrentBib(state),
  editions: selectEditionsForCurrentBib(state),
  summary: selectManifestationsSummary(state)
});

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FormatChooserContainer);
